import AdminConfig from './admin.vue';

import ClientView from './client.vue';


export default {
  name : 'frontdatas',

  type : 'module',
  
  label: 'Datas en front',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-database-arrow-down',
  }
}